var render = function (_h,_vm) {var _c=_vm._c;return _c('button',{staticClass:"custom_button",class:[_vm.props.classes],attrs:{"title":_vm.props.title || ''}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }